import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RouteContextProviderService {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  public navigateTo(routeURL: string[] | string, target?: string): void {
    if (typeof routeURL === 'object') {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.router.navigate(routeURL);
    } else {
      window.open(routeURL, target);
    }
  }

  public getParams(key: string): string {
    return this.route.snapshot.params[key];
  }
  public getQueryParams(key: string): string {
    return this.route.snapshot.queryParams[key];
  }
}
